import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Validators, FormGroup, FormBuilder, FormsModule } from '@angular/forms';
import { SecurityService } from '../../services/security';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: true,
  imports: [
    FormsModule
],
})
export class LoginComponent implements OnInit {

  formError: boolean = false;
  username: string = '';
  password: string = '';

  constructor(
    private router: Router,
    private __securityService: SecurityService
  ) {}

  ngOnInit(): void {
  }

  login(){
    if(this.username.length == 0 || this.password.length == 0) {
      return;
    }
    let param = {
      "password": this.password,
      "mail": this.username,
      "loginType": 0
    }

    this.__securityService.authentication(param).subscribe( (data: any) => {
      if(data.an_resultado == 1){
        localStorage.setItem('user', data.res_obj_login.username)
        localStorage.setItem('name', data.res_obj_login.name);
        localStorage.setItem('mail', data.res_obj_login.mail);
        localStorage.setItem('token_one', data.res_obj_login.token);
        if (data.res_obj_login.permissions.roles[0]?.roleDesc?.length > 0) {
          sessionStorage.setItem('profile', data.res_obj_login.permissions.roles[0]?.roleDesc);
        }
        sessionStorage.setItem('permissions', JSON.stringify(data.res_obj_login.permissions));
        this.router.navigate(['/data-management']);
      }
    });

  }

}
